import * as React from "react";
import { useEffect, useState } from "react";

import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { ModalComponent } from "shared/components/modal/modal";
import { IAvailableDateModel } from "states/order/order.models";
import { getAvailableDateAPI } from "states/order/order.api";
import momentTz from "moment-timezone";
import { momentDateTimeFormat } from "shared/plugins/localization";
import { useAppSelector } from "app.hook";
import { shallowEqual } from "react-redux";
import { RootState } from "app.store";
interface IPickupTime {
  onChange: (time?: Date) => void;
  value?: Date;
}
export const PickupTime = ({ value, onChange }: IPickupTime) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [availableDates, setAvailableDates] = useState<IAvailableDateModel[]>(
    []
  );

  const [selectCurrentDate, setSelectCurrentDate] = useState("");
  const [selectCurrentTime, setSelectCurrentTime] = useState("");

  const branch = useAppSelector(
    (state: RootState) => state.shoppingCart.shoppingCart.branch,
    shallowEqual
  );
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    getAvailableDateAPI(branch?.id).then((availableDates) => {
      let newAvailableDates = availableDates.data.filter(
        (m) => m.times.length > 0
      );
      setAvailableDates(newAvailableDates);
      if (
        newAvailableDates.length > 0 &&
        newAvailableDates[0].times.length > 0
      ) {
        if (!value) {
          onChange(newAvailableDates[0].times[0].time);
          setSelectCurrentTime(
            momentTz(newAvailableDates[0].times[0].time)
              .tz(branch.ianaTimeZone)
              .format(momentDateTimeFormat())
          );
        }
        setSelectCurrentDate(newAvailableDates[0].day);
      }
    });
  }, []);

  return (
    <React.Fragment>
      <div onClick={handleOpenModal} className="pickup-time-card" >
        <div className="pickup-time-info">
          <span className="pickup-icon">🕐</span>
          <div className="pickup-details">
            <h4>Pick up at</h4>
            <div className="pickup-time">{value && branch?.id !== undefined && availableDates?.length > 0
              ? momentTz(value)
                .tz(branch?.ianaTimeZone)
                .format(momentDateTimeFormat())
              : ""}</div>
          </div>
        </div>
        <button className="change-time-btn" onClick={(ev) => { ev.stopPropagation(); handleOpenModal() }}>CHANGE TIME  <FontAwesomeIcon icon={faChevronRight} /></button>
      </div>
      <ModalComponent
        width={`100%`}
        height={`100%`}
        isModal={false}
        className="w-full bg-white rounded-2xl"
        isCustomizeFooter={true}
        onCloseModal={handleCloseModal}
        isOpenModal={modalIsOpen}
        title={`Pickup time`}
      >
        <div className="pt-3">
          <select
            className="select-container mb-2"
            name="date"
            value={selectCurrentDate}
            onChange={(ev) => {
              setSelectCurrentDate(ev.target.value);
              const newTime = availableDates.find(
                (m) => m.day === ev.target.value
              )?.times[0].time;
              setSelectCurrentTime("");
              if (newTime) {
                setSelectCurrentTime(
                  momentTz(newTime)
                    .tz(branch?.ianaTimeZone)
                    .format(momentDateTimeFormat())
                );
              }
            }}
          >
            {availableDates?.map((m) => (
              <option key={m.day} value={m.day}>
                {m.day}
              </option>
            ))}
          </select>
          <select
            className="select-container  mb-2"
            name="time"
            value={selectCurrentTime}
            onChange={(ev) => {
              setSelectCurrentTime(ev.target.value);
            }}
          >
            {branch?.id && selectCurrentDate && availableDates
              ?.find((m) => m.day === selectCurrentDate)
              ?.times?.map((m) => (
                <option
                  key={m.displayText}
                  value={momentTz(m.time)
                    .tz(branch?.ianaTimeZone)
                    .format(momentDateTimeFormat())}
                >
                  {m.displayText}
                </option>
              ))}
          </select>
          <button
            onClick={() => {
              let timeDefault = availableDates?.find(
                (m) => m.day === selectCurrentDate
              )?.times[0]?.time;
              onChange(
                selectCurrentTime !== ""
                  ? momentTz
                    .tz(
                      selectCurrentTime,
                      momentDateTimeFormat(),
                      branch.ianaTimeZone
                    )
                    .toDate()
                  : timeDefault
              );
              handleCloseModal();
            }}
            className="w-full btn--default text-center mt-3 px-1.5 py-6 rounded-full flex justify-between content-center items-center btn--primary"
          >
            <span className="w-full block uppercase font-semibold text-center">
              {" "}
              Confirm
            </span>
          </button>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};
